import React, { useEffect, useState } from 'react';

interface saveSearchProps {
	query: string;
	onClose: () => void;
	onSubmit: (name: string) => void;
	modelref: React.RefObject<HTMLDivElement>;
}

interface FormData {
	name: string;
}

export const SaveCustomSearch: React.FC<saveSearchProps> = ({
	query,
	onClose,
	modelref,
	onSubmit,
}) => {
	const [name, setName] = useState<string>('');
    const [errors, setErrors] = useState<Partial<FormData>>({});
    
    useEffect(() => {
        setName(query);
    },[query])

	const handleChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		setName(e.target.value);
		// Clear error when field is being edited
		if (errors[name as keyof FormData]) {
			setErrors((prev) => ({
				...prev,
				[name]: undefined,
			}));
		}
	};

	const validate = (): boolean => {
		const newErrors: Partial<FormData> = {};

		if (!name) {
			newErrors.name = 'Query Name is required';
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = () => {
		if (validate()) {
			onSubmit(name);
		}
    };


	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="min-h-screen w-full py-8 px-4 flex items-center justify-center">
				<div
					className="flex flex-col justify-center  bg-[#fff] shadow-custom p-4 w-[90%] max-w-[500px] border border-light-gray overflow-y-auto max-h-[90vh]"
					ref={modelref}
				>
					<div className="flex justify-between items-center">
						<h2 className="text-xl font-semibold text-gray-800">
							Save Custom Search
						</h2>
						<button
							onClick={onClose}
							className="text-gray-500 hover:text-gray-700"
							aria-label="Close"
						>
							<span className="text-2xl">&times;</span>
						</button>
					</div>

					<form>
						<div className="my-12">
							<label htmlFor="email" className="block text-gray-700 mb-1">
								Query Name <span className="text-red-500">*</span>
							</label>
							<input
								type="text"
								id="name"
								name="name"
								value={name}
								onChange={handleChange}
								className={`w-full p-2 border rounded-md ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
							/>
							{errors.name && (
								<p className="text-red-500 text-sm mt-1">{errors.name}</p>
							)}
						</div>
						<button
							type="submit"
                            className="w-full btn-dark text-white py-2 px-4 rounded-md transition duration-200"
                            onClick={handleSubmit}
						>
							Save
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};
